import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import Header from './Header';
import PageContainer from '../UI/PageContainer';
import ClinicPickerGate from './ClinicPickerGate';

const MainLayout = () => {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isTherapist = user?.role === 'therapist';

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile sidebar overlay (therapists use bottom tabs — no drawer) */}
      {sidebarOpen && !isTherapist && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      {/* Main content */}
      <div className="lg:pl-56">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        
        <main
          className={`px-3 py-4 sm:px-4 lg:px-6 lg:py-6 ${
            isTherapist
              ? 'max-lg:pb-[calc(6.5rem+env(safe-area-inset-bottom,0px))]'
              : ''
          }`}
        >
          <PageContainer>
            <ClinicPickerGate>
              <Outlet />
            </ClinicPickerGate>
          </PageContainer>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;

